import { supabase } from './supabase';

function getSessionId(): string {
  let id = localStorage.getItem('professya_session_id');
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem('professya_session_id', id);
  }
  return id;
}

export type OnboardingEventType =
  | 'landing_page_view'
  | 'register_cta_clicked'
  | 'step1_email_started'
  | 'step1_email_completed'
  | 'step2_birthdata_started'
  | 'step2_birthdata_completed'
  | 'email_confirmation_sent'
  | 'email_confirmed'
  | 'map_generation_started'
  | 'map_generation_completed'
  | 'aha_moment_viewed'
  | 'upgrade_cta_clicked';

export async function trackOnboardingEvent(
  eventType: OnboardingEventType,
  opts: { email?: string; metadata?: Record<string, unknown> } = {}
): Promise<void> {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    await supabase.from('onboarding_events').insert({
      session_id:     getSessionId(),
      user_id:        user?.id ?? null,
      email:          opts.email ?? user?.email ?? null,
      event_type:     eventType,
      event_metadata: opts.metadata ?? {},
      page_url:       window.location.href,
      referrer:       document.referrer,
      user_agent:     navigator.userAgent,
    });
  } catch {
    // Never block UX for analytics
  }
}

export async function trackAbandonment(
  stage: 'step1_email' | 'step2_birthdata' | 'email_confirmation' | 'map_viewing',
  email: string,
  partialData: Record<string, unknown> = {}
): Promise<void> {
  try {
    await supabase.from('onboarding_abandonments').upsert(
      {
        email,
        session_id:          getSessionId(),
        abandoned_at_stage:  stage,
        last_activity_at:    new Date().toISOString(),
        partial_data:        partialData,
      },
      { onConflict: 'email,abandoned_at_stage' }
    );
  } catch {
    // Silent
  }
}

// Auto-track landing page views
if (typeof window !== 'undefined' && window.location.pathname === '/') {
  trackOnboardingEvent('landing_page_view');
}
